module.exports = __webpack_public_path__ + "img/40_38_055_560.65f13e4c.jpg";